export default __webpack_public_path__ + "static/media/pic404.2422ce6a.svg";